<div [vxWatch]="globalModel?.siteMessage" class="banner">
  <img class="banner-icon" src="assets/default-image.png">
  <span class="banner-text">{{globalModel?.siteMessage}}</span>
</div>
